module.exports = __webpack_public_path__ + "img/freelogo.35069cd1.png";